import * as React from 'react'
import { Box, IconButton, makeStyles, TextField, Theme } from 'cs-kevlar-react'
import { TextFieldProps } from 'cs-kevlar-react/lib/es/TextField'
import { Close, OpenInNew } from '@mui/icons-material'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'

const useStyles = makeStyles((theme: Theme) => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  adornedButton: {
    marginRight: theme.spacing(4)
  }
}))

const formatValue = (value: unknown, formatAsCommaDelimited: boolean) => {
  const stringValue = (value as object)?.toString()
  return formatAsCommaDelimited
    ? stringValue.split(",").map(x => x.trim()).join(",\n")
    : stringValue
}

type TextFieldWithFullscreen = TextFieldProps & {
  isCommaDelimited?: boolean
}

export const TextFieldWithFullscreen: React.FunctionComponent<TextFieldWithFullscreen> = ({
  label,
  value,
  isCommaDelimited = false,
  ...rest
}) => {
  const classes = useStyles()
  const [isFullView, setFullView] = React.useState(false)

  return (
    <React.Fragment>
      <TextField
        value={value}
        multiline
        fullWidth
        label={label}
        InputProps={{
          startAdornment: (
            <IconButton
              title='View full screen'
              className={classes.adornedButton}
              onClick={() => setFullView(true)}
              size="large">
              <OpenInNew />
            </IconButton>
          )
        }}

        {...rest}
      />

      <Dialog
        fullScreen={true}
        maxWidth={false}
        open={isFullView}
        onClose={() => setFullView(false)}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Box>{label}</Box>
          <IconButton title='Close' onClick={() => setFullView(false)} size="large">
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <pre>
            {formatValue(value, isCommaDelimited)}
          </pre>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
